export const AUTH_ERROR_CODES = {
    RESEND_COOLDOWN: "resend_cooldown",
    INVALID_CODE: "invalid_code",
    CODE_EXPIRED: "expired",
    MAX_ATTEMPTS: "max_attempts",
    NO_REFRESH_TOKEN: "no_refresh_token",
    INVALID_REFRESH_TOKEN: "invalid_refresh_token",
    USER_NOT_FOUND: "user_not_found",
    CSRF_TOKEN_INVALID: "csrf_token_invalid",
    CSRF_TOKEN_MISSING: "csrf_token_missing",
};
export function isApiError(err) {
    if (typeof err !== "object" || err === null || !("data" in err))
        return false;
    const data = err.data;
    return typeof data === "object" && data !== null && "error" in data && typeof data.error === "string";
}
